import React from "react";
import { useLocation } from "react-router-dom";
import AdminSidebar from "../pages/AdminPanel/components/AdminSidebar";

function AdminLayout({ children, currentPage, customWrapper, customContentClass }) {
    const location = useLocation();

    if (customWrapper) {
        return (
            <div className="relative">
                <AdminSidebar currentPage={currentPage} />
                <div
                    key={location.pathname}
                    className={`${customContentClass || "ml-64 p-8"} transition-all duration-300 ease-in-out`}
                    style={{
                        transform: 'translateZ(0)',
                        backfaceVisibility: 'hidden',
                        WebkitFontSmoothing: 'antialiased'
                    }}
                >
                    <div className="animate-fadeIn">
                        {children}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
            <AdminSidebar currentPage={currentPage} />
            <div
                key={location.pathname}
                className="ml-64 p-8 transition-all duration-300 ease-in-out min-h-screen"
                style={{
                    transform: 'translateZ(0)',
                    backfaceVisibility: 'hidden',
                    WebkitFontSmoothing: 'antialiased'
                }}
            >
                <div className="animate-fadeIn">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AdminLayout;